export class printDestinationModel {
    id: number;
    companyId: number;
    name: string;
    sector: string;
    status: number;

    constructor() {
        this.id             = 0;
        this.companyId      = 0;
        this.name           = '';
        this.sector         = '';
        this.status         = 1;
    }
}
